module.exports = __webpack_public_path__ + "img/p04.385c1e06.jpg";